import React from 'react'
import { GroundPlanContext } from 'src/contexts'
import { event as d3Event, zoom as d3Zoom, zoomIdentity } from 'd3'
import { useD3Selection } from 'src/hooks'
import { PlanZoomObserver } from 'src/observers'
import styles from './BackgroundMouseEvents.scss'

const BackgroundMouseEvents = () => {
  // init D3 selection
  const [ref, useSelectionEffect] = useD3Selection()

  // retrieve context props
  const { height, width } = GroundPlanContext.use()

  // init zoom behavior
  const zoom = React.useMemo(
    () =>
      d3Zoom()
        .scaleExtent([1, 5])
        .on('zoom', () => {
          const { x, y, k } = d3Event.transform
          PlanZoomObserver.set(zoomIdentity.translate(x, y).scale(k))
        }),
    []
  )

  // init selection with zoom on mount and remove on unmount
  useSelectionEffect(selection => {
    zoom(selection)
    zoom.transform(selection, PlanZoomObserver.value)
    return () => selection.on('.zoom', null)
  }, [])

  // subscribe to zoom transforms
  useSelectionEffect(selection => PlanZoomObserver.subscribe(value => zoom.transform(selection, value)), [zoom])

  return <rect className={styles.backgroundMouseEvents} width={width} height={height} ref={ref} />
}

export default BackgroundMouseEvents
